export const openLinkedIn = () => {
    window.open("https://www.linkedin.com/company/pontes-tecnologia-e-inovação", "_blank");
};